/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import { Box, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

export const TagListContainer = styled(Box)(() => ({
  display: "flex",
  alignItems: "center",
  gap: 8,
  width: "100%",
  overflow: "hidden",
}));

// Holds the ref used to measure a tag before it is laid out. Shrink-wraps its child so the
// measured width is the tag's own width.
export const MeasurementItem = styled(Box)(() => ({
  display: "inline-flex",
  flexShrink: 0,
}));

export const MeasurementLayer = styled(Box)(() => ({
  position: "absolute",
  visibility: "hidden",
  pointerEvents: "none",
  height: 0,
  overflow: "hidden",
  whiteSpace: "nowrap",
}));

export const OverflowBadge = styled(Box)(() => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  minWidth: 30,
  height: 28,
  borderRadius: 999,
  backgroundColor: "lightgray",
  cursor: "pointer",
  fontSize: 14,
  flexShrink: 0,
  color: "gray",
}));

export const EmptyLabel = styled(Typography)(() => ({
  color: "#71717A",
  fontSize: 14,
}));

export const PopoverContent = styled(Box)(() => ({
  display: "flex",
  flexDirection: "column",
  gap: 8,
  minWidth: 250,
}));
